$ = require 'jquery'
BoardMemberMenuView = require 'views/member-menu-profile/board-member-menu-view'
DragSort = require 'views/lib/drag-sort'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
assert = require 'lib/assert'
log = require 'debug/log'
template = require 'views/templates/member'

module.exports = class MemberOnBoardView extends View
  className: 'member js-member'

  events:
    'click': 'showMenu'

  initialize: ({ @board }) ->
    assert @model?, "You cannot have a deleted member as a board member!"
    @listenTo @model, 'change', @render
    @listenTo @board, 'change:memberships', @render
    return

  render: ->
    log('render', "rendering #{ @constructor.name } #{ @model.get('fullName') }")
    data = @model.toJSON()

    isAdmin = (parent) =>
      membership = parent.getMembershipFor(@model)
      membership?.memberType == 'admin'

    # if the person is a BC org admin, then they are board admin, too, dang it
    data.isBoardAdmin = isAdmin(@board) ||
      @board.getOrganization()?.isPremOrgAdmin(@model)

    data.isGhost = @model.get('memberType') == 'ghost'
    data.isDeactivated = @board.isDeactivated(@model)

    @$el.html(template(data))

    if @model.isFeatureEnabled('crown')
      @$el.addClass('has-crown')

    @$el.toggleClass('member-deactivated js-member-deactivated', data.isDeactivated)

    if data.isGhost
      @$el.addClass('member-virtual')

    @$el.data('id', @model.id)
    @

  showMenu: (e) ->
    if !@doClicks()
      return

    Util.stop(e)

    PopOver.toggle
      elem: e.currentTarget
      view: new BoardMemberMenuView({ @board, @model, @modelCache })

    return

  doClicks: -> !DragSort.sorting



// WEBPACK FOOTER //
// ./app/scripts/views/member-menu-profile/member-on-board-view.coffee